import { useCatalogRegistrationModalContext } from '../RegistrationModals/CatalogRegistrationModal/hooks/useCatalogRegistrationModalContext'

export const useOpenStartCatalogRegistrationModal = () =>
  useCatalogRegistrationModalContext().modal.show
